export * from '@primeuix/themes/nora/card';
export { default } from '@primeuix/themes/nora/card';
